import React from "react";
import { useState } from "react";
import { btnStyle } from '../../styles/theme';

import LevelingView from './LevelingView';
import CharacterDetails from '../character/CharacterDetails';
// ─── LEVELING SCREEN ────────────────────────────────────────────────────────
function LevelingScreen({ character, setCharacter, expPools, setExpPools, onSave }) {
  const [view, setView] = useState("leveling"); // "leveling" or "details"

  if (!character) return <div style={{ padding: 40, textAlign: "center", color: "#8a7e5e" }}>Loading character...</div>;

  return (
    <>
      {/* View Toggle */}
      <div style={{ position: "relative", zIndex: 1, display: "flex", justifyContent: "center", gap: "8px", padding: "0 16px", marginBottom: 16 }}>
        <button onClick={() => setView("leveling")}
          style={{
            ...btnStyle(view === "leveling" ? "#c9a84c" : "#6b6048", view === "leveling" ? "rgba(201,168,76,0.15)" : "transparent"),
            padding: "8px 20px"
          }}>
          Leveling
        </button>
        <button onClick={() => setView("details")}
          style={{
            ...btnStyle(view === "details" ? "#c9a84c" : "#6b6048", view === "details" ? "rgba(201,168,76,0.15)" : "transparent"),
            padding: "8px 20px"
          }}>
          Character Details
        </button>
      </div>

      {view === "leveling" ? (
        <LevelingView character={character} setCharacter={setCharacter} expPools={expPools} setExpPools={setExpPools} />
      ) : (
        <CharacterDetails character={character} setCharacter={setCharacter} onSave={() => onSave(character, expPools)} />
      )}
    </>
  );
}

export default LevelingScreen
